class VIPPointsExchangeList extends HTMLElement {
  constructor() {
    super();
    this.customer_has_login = this.dataset.customer === 'true';
    this.template = this.querySelector('.vip-points-exchange__item').cloneNode(true);
    this.container = this.querySelector('[data-container]');
    this.grid = this.querySelector('[data-grid]');
    this.loading = this.querySelector('[data-loading]');
    this.empty = this.querySelector('[data-empty]');
    this.pagination = this.querySelector('[data-pagination]');
    this.isSubmitting = false;

    this.page = 1;
    this.pageSize = 4;
    this.totalPages = 0;

    this.modal = this.querySelector('#redeemConfirmModal');
    this.confirmView = this.modal.querySelector('.redeem-modal__confirm');
    this.codeView = this.modal.querySelector('.redeem-modal__code');
    this.currentDiscount = null;
  }

  connectedCallback() {
    this.setupEventListeners();
    this.fetchDiscounts(true);
  }

  setupEventListeners() {
    // 兑换按钮点击
    this.addEventListener('click', (e) => {
      const redeemButton = e.target.closest('.vip-points-exchange__item-button');
      if (redeemButton && !redeemButton.classList.contains('g-button--disabled')) {
        const discountId = redeemButton.dataset.discountId;
        if (discountId) {
          this.handleRedeem(discountId);
        }
      }
    });

    this.pagination?.addEventListener('page-change', (e) => {
      this.page = e.detail.page;
      this.fetchDiscounts();
    });

    // 添加弹窗按钮事件监听
    this.modal.addEventListener('click', (e) => {
      const action = e.target.closest('[data-action]')?.dataset.action;
      if (action) {
        switch (action) {
          case 'cancel':
            this.modal.close();
            break;
          case 'confirm':
            this.handleConfirmRedeem();
            break;
          case 'copy':
            this.handleCopyCode();
            break;
        }
      }
    });
  }

  showLoading() {
    this.loading.classList.remove('g:hidden');
    this.container.classList.add('g:hidden');
    this.empty.classList.add('g:hidden');
  }

  hideLoading() {
    this.loading.classList.add('g:hidden');
  }

  showEmpty() {
    this.empty.classList.remove('g:hidden');
    this.container.classList.add('g:hidden');
    this.pagination.classList.add('g:hidden');
  }

  showContent() {
    this.empty.classList.add('g:hidden');
    this.container.classList.remove('g:hidden');
    this.togglePagination(this.totalPages > 1);
  }

  togglePagination(show) {
    if (show) {
      this.pagination.classList.remove('g:hidden');
    } else {
      this.pagination.classList.add('g:hidden');
    }
  }

  async fetchDiscounts(isInitialLoad = false) {
    try {
      this.showLoading();

      const response = await fetch(
        `/apps/esrvip/common/exchanheable-discounts?page=${this.page}&limit=${this.pageSize}`
      );
      const data = await response.json();

      if (data.code === 200) {
        const { count, list } = data.data;
        this.totalPages = Math.ceil(count / this.pageSize);

        if (!list || list.length === 0) {
          this.showEmpty();
        } else {
          this.renderDiscounts(list);
          this.updatePagination();
          this.showContent();
        }
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      console.error('Failed to fetch discounts:', error);
      this.showEmpty();
    } finally {
      this.hideLoading();
    }
  }

  updatePagination() {
    if (this.pagination) {
      this.togglePagination(this.totalPages > 1);
      this.pagination.setAttribute('total-pages', this.totalPages);
      this.pagination.setAttribute('current-page', this.page);
    }
  }

  async handleRedeem(discountId) {
    if (!this.customer_has_login || this.isSubmitting) {
      return;
    }

    const button = this.querySelector(`[data-discount-id="${discountId}"]`);
    if (!button) return;

    // 获取当前折扣信息
    const discountTitle = button
      .closest('.vip-points-exchange__item')
      .querySelector('.vip-points-exchange__item-title').textContent;
    const pointsValue = button
      .closest('.vip-points-exchange__item')
      .querySelector('.vip-points-exchange__item-points-value').textContent;

    // 获取当前折扣的优惠码
    const discountCode = button
      .closest('.vip-points-exchange__item')
      .querySelector('.vip-points-exchange__item-code-text').textContent;

    // 显示确认弹窗
    this.currentDiscount = { id: discountId, title: discountTitle, points: pointsValue, code: discountCode };
    this.showConfirmView(discountTitle);
    this.modal.open();
  }

  async handleConfirmRedeem() {
    if (!this.currentDiscount || this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      const confirmButton = this.modal.querySelector('[data-action="confirm"]');
      confirmButton.classList.add('g-button--loading');

      const button = this.querySelector(`[data-discount-id="${this.currentDiscount.id}"]`);
      button.classList.add('g-button--loading');

      const formData = new FormData();
      formData.append('discount_id', this.currentDiscount.id);
      formData.append('type', 'exchange_discount');

      const response = await fetch('/apps/esrvip/vip/exchange-discount', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.code === 200) {
        // 显示优惠码视图
        this.showCodeView(this.currentDiscount.code);
      } else {
        throw new Error(data.message || 'Failed to redeem');
      }
    } catch (error) {
      this.showError(error.message);
      this.modal.close();
    } finally {
      this.isSubmitting = false;
      const confirmButton = this.modal.querySelector('[data-action="confirm"]');
      confirmButton.classList.remove('g-button--loading');
      const button = this.querySelector(`[data-discount-id="${this.currentDiscount.id}"]`);
      button.classList.remove('g-button--loading');
    }
  }

  async handleCopyCode() {
    const codeText = this.modal.querySelector('.redeem-modal__code-input').value;
    try {
      await navigator.clipboard.writeText(codeText);
      const copyButton = this.modal.querySelector('[data-action="copy"]');
      const originalText = copyButton.textContent;
      copyButton.textContent = 'Copied!';
      setTimeout(() => {
        copyButton.textContent = originalText;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }

  showConfirmView(title) {
    this.confirmView.classList.remove('g:hidden');
    this.codeView.classList.add('g:hidden');
    this.modal.querySelector('.redeem-modal__product-title').textContent = title;
  }

  showCodeView(code) {
    this.confirmView.classList.add('g:hidden');
    this.codeView.classList.remove('g:hidden');
    this.modal.querySelector('.redeem-modal__code-title').textContent = this.currentDiscount.title;
    this.modal.querySelector('.redeem-modal__code-points span').textContent = this.currentDiscount.points;
    this.modal.querySelector('.redeem-modal__code-input').value = code;
  }

  showError(message) {
    document.dispatchEvent(
      new CustomEvent('notification:show', {
        detail: {
          showOptions: {
            type: 'error',
            message,
            last: 3000,
          },
        },
      })
    );
  }

  renderDiscounts(discounts) {
    this.grid.innerHTML = '';

    discounts.forEach((discount) => {
      const item = this.template.cloneNode(true);
      item.classList.remove('g:hidden');

      // 更新标题和内容
      item.querySelector('.vip-points-exchange__item-title').textContent = discount.short_summary;
      item.querySelector('.vip-points-exchange__item-subtitle').textContent = discount.summary?.[0] || '';


      const pointsValue = item.querySelector('.vip-points-exchange__item-points-value');
      pointsValue.textContent = discount.point_value;

      // 更新按钮状态
      const button = item.querySelector('.vip-points-exchange__item-button');
      button.dataset.discountId = discount.id;

      // 更新优惠码
      const code = item.querySelector('.vip-points-exchange__item-code-text');
      code.textContent = discount.title;

      // 检查积分值是否有效
      const points = parseInt(discount.point_value);
      if (isNaN(points) || points <= 0) {
        button.classList.add('g-button--disabled');
        button.disabled = true;
      }

      this.grid.appendChild(item);
    });
  }

  renderDiscountSummary(summary) {
    return summary.join('\n');
  }
}

customElements.define('vip-points-exchange-list', VIPPointsExchangeList);
